import React, { useMemo } from 'react';
import { Tree, theme } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { buildTree } from './CustomTreeLevel';

export const mapTree = (
  nodes: any[],
  render: (node: any, level: number) => React.ReactNode,
  level = 0
): DataNode[] =>
  nodes.map((node) => ({
    key: node.key,
    title: render(node, level),

    children: node.children?.length
      ? mapTree(node.children, render, level + 1)
      : undefined
  }));

type DependencyTreeProps = {
  data: any[];

  levels: any[];

  renderNode: (node: any, level: number, token: any) => React.ReactNode;
};

export const DependencyTree = ({
  data,
  levels,
  renderNode
}: DependencyTreeProps) => {
  const { useToken } = theme;
  const { token } = useToken();

  const tree = useMemo(() => buildTree(data, levels), [data, levels]);

  const treeData = useMemo(
    () => mapTree(tree, (node, level) => renderNode(node, level, token)),
    [tree, token, renderNode]
  );

  return <Tree treeData={treeData} showLine />;
};
